import React from 'react';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@beef/ui-kit';
import { withRenderFlag } from '@beef/react';
import { Metric } from "../../metric";
import { Stores } from "./types";
import styles from "./styles.pcss";
import { Android as _Android, IOS as _IOS } from "./utils";
var cx = classNames.bind(styles);
var Android = withRenderFlag(_Android);
var IOS = withRenderFlag(_IOS);
export var StoresIcons = function StoresIcons(_ref) {
  var storeLinks = _ref.storeLinks,
    icons = _ref.icons,
    theme = _ref.theme;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cx('stores'),
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement(Android, {
    shouldRender: storeLinks[Stores.Android]
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "google",
    events: {
      footerMetric: ['handleClickIcon']
    },
    mode: "click",
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": Stores.Android,
    className: cx('stores__icon', "icon-theme__".concat(theme)),
    href: storeLinks[Stores.Android],
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__icon-img'),
    loading: "lazy",
    src: icons.googleStore
  }), ' '))), /*#__PURE__*/React.createElement(Android, {
    shouldRender: storeLinks[Stores.Huawei]
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "huawei",
    events: {
      footerMetric: ['handleClickIcon']
    },
    mode: "click",
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": Stores.Huawei,
    className: cx('stores__icon', "icon-theme__".concat(theme)),
    href: storeLinks[Stores.Huawei],
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__icon-img'),
    loading: "lazy",
    src: icons.appGallery
  })))), /*#__PURE__*/React.createElement(Android, {
    shouldRender: storeLinks[Stores.RuStore]
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "rustore",
    events: {
      footerMetric: ['handleClickIcon']
    },
    mode: "click",
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": Stores.RuStore,
    className: cx('stores__icon', "icon-theme__".concat(theme)),
    href: storeLinks[Stores.RuStore],
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__icon-img'),
    loading: "lazy",
    src: icons.ruStore
  })))), /*#__PURE__*/React.createElement(IOS, {
    shouldRender: storeLinks[Stores.IOS]
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "ios",
    events: {
      footerMetric: ['handleClickIcon']
    },
    mode: "click",
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": Stores.IOS,
    className: cx(isMobile ? 'stores__icon-full-width' : 'stores__icon', "icon-theme__".concat(theme)),
    href: storeLinks[Stores.IOS],
    "data-t-id": "components-StoreIcons"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx(isMobile ? 'stores__icon-img-full' : 'stores__icon-img'),
    loading: "lazy",
    src: isMobile ? icons.appStoreFull : icons.appStore
  })))));
};